import { LOCALE_BCP47 } from '@staiter/shared';
export function formatDate(iso, locale, options) {
    if (!iso)
        return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return '—';
    return new Intl.DateTimeFormat(LOCALE_BCP47[locale], {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        ...options,
    }).format(d);
}
export function formatDateTime(iso, locale, options) {
    if (!iso)
        return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return '—';
    return new Intl.DateTimeFormat(LOCALE_BCP47[locale], {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        ...options,
    }).format(d);
}
export function formatRelativeTime(iso, locale) {
    if (!iso)
        return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return '—';
    const rtf = new Intl.RelativeTimeFormat(LOCALE_BCP47[locale], { numeric: 'auto' });
    const diffMs = d.getTime() - Date.now();
    const diffMin = Math.round(diffMs / 60000);
    if (Math.abs(diffMin) < 60)
        return rtf.format(diffMin, 'minute');
    const diffHour = Math.round(diffMin / 60);
    if (Math.abs(diffHour) < 24)
        return rtf.format(diffHour, 'hour');
    const diffDay = Math.round(diffHour / 24);
    return rtf.format(diffDay, 'day');
}
/**
 * Возвращает pattern/parse/format helpers для input primitives.
 * ru/kk: DD.MM.YYYY, en: MM/DD/YYYY, zh: YYYY/MM/DD.
 */
export function getLocaleDateFormat(locale) {
    const config = {
        ru: { pattern: 'DD.MM.YYYY', sep: '.', order: ['day', 'month', 'year'] },
        kk: { pattern: 'DD.MM.YYYY', sep: '.', order: ['day', 'month', 'year'] },
        en: { pattern: 'MM/DD/YYYY', sep: '/', order: ['month', 'day', 'year'] },
        zh: { pattern: 'YYYY/MM/DD', sep: '/', order: ['year', 'month', 'day'] },
    }[locale];
    return {
        pattern: config.pattern,
        placeholder: config.pattern,
        parse(s) {
            const parts = s.split(config.sep);
            if (parts.length !== 3)
                return null;
            const map = {};
            config.order.forEach((k, i) => {
                map[k] = parts[i] ?? '';
            });
            const year = Number(map.year);
            const month = Number(map.month);
            const day = Number(map.day);
            if (!year || !month || !day)
                return null;
            const d = new Date(Date.UTC(year, month - 1, day));
            if (Number.isNaN(d.getTime()))
                return null;
            return d.toISOString().slice(0, 10);
        },
        format(iso) {
            return formatDate(iso, locale);
        },
    };
}
//# sourceMappingURL=date.js.map